import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  usersList: [],
  hqBranchesList: [],
  branchesDeps: [],
  sidebar_referral_count: 0,
};

export const helperSlice = createSlice({
  name: "helper",
  initialState,
  reducers: {
    setUsersList: (state, action) => {
      state.usersList = action.payload;
    },
    setHqBranchesList: (state, action) => {
      state.hqBranchesList = action.payload;
    },
    setBranchesDeps: (state, action) => {
      state.branchesDeps = action.payload;
    },
    setSidebarReferralCount: (state, action) => {
      state.sidebar_referral_count = action.payload;
    }
  },
});

export const { setUsersList, setHqBranchesList, setBranchesDeps, setSidebarReferralCount } =
  helperSlice.actions;
